module.exports = __webpack_public_path__ + "img/3d_logo_invert.f854ad86.png";